module.exports = __webpack_public_path__ + "static/img/color.3d84e6c8.png";